"use client";

import { IServerRenderedTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";
import React, { createContext, ReactNode, useContext } from "react";

export type ServerRenderedProductTileBatch = {
  serverRenderedProductTiles: IServerRenderedTile[] | undefined;
  batchRenderedPromise: Promise<number>;
};

const ServerRenderedProductTilesContext = createContext<
  | {
      firstServerRenderedProductTilesBatch:
        | ServerRenderedProductTileBatch
        | undefined;
      serverRenderedIrrelevantProductTiles: IServerRenderedTile[] | undefined;
      remainingServerRenderedProductTiles: Promise<
        ServerRenderedProductTileBatch | undefined
      >;
    }
  | undefined
>(undefined);

export const useServerRenderedProductTiles = () =>
  useContext(ServerRenderedProductTilesContext);

export const ServerRenderedProductTilesContextProvider = ({
  firstServerRenderedProductTilesBatch,
  serverRenderedIrrelevantProductTiles,
  remainingServerRenderedProductTiles,
  children,
}: {
  firstServerRenderedProductTilesBatch:
    | ServerRenderedProductTileBatch
    | undefined;
  serverRenderedIrrelevantProductTiles: IServerRenderedTile[] | undefined;
  remainingServerRenderedProductTiles: Promise<
    ServerRenderedProductTileBatch | undefined
  >;
  children: ReactNode;
}) => {
  return (
    <ServerRenderedProductTilesContext.Provider
      value={{
        firstServerRenderedProductTilesBatch,
        serverRenderedIrrelevantProductTiles,
        remainingServerRenderedProductTiles,
      }}
    >
      {children}
    </ServerRenderedProductTilesContext.Provider>
  );
};
